module.exports = __webpack_public_path__ + "static/media/banner-back1.d993658d.png";